import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SectionHeader, Button, Loading, EmptyState, Avatar, Tag } from "@/components/brand";
import { formatDayTime, formatR } from "@/lib/format";

export default function AdminBookings() {
  const qc = useQueryClient();
  const bookings = useQuery({ queryKey: ["admin", "bookings"], queryFn: () => api("/admin/bookings") });
  const refund = useMutation({ mutationFn: (id) => api(`/admin/bookings/${id}/refund`, { method: "POST" }), onSuccess: () => { qc.invalidateQueries({ queryKey: ["admin", "bookings"] }); toast.success("Refunded"); }, onError: (e) => toast.error(e.message) });
  const tone = (s) => s === "completed" ? "green" : s === "confirmed" ? "pink" : s === "refunded" ? "grey" : "dark";

  return (
    <div data-testid="admin-bookings-screen" className="space-y-5">
      <SectionHeader title="Bookings" subtitle="All bookings across the platform." />
      {bookings.isLoading ? <Loading /> : (bookings.data ?? []).length === 0 ? <EmptyState title="No bookings" /> : (
        <div className="space-y-2">
          {bookings.data.map((b) => (
            <div key={b.id} data-testid={`admin-booking-${b.id}`} className="flex items-center gap-3 p-3 rounded-xl2 border border-divider">
              <Avatar uri={b.trainer_avatar} size={40} name={b.trainer_name} />
              <div className="flex-1 min-w-0">
                <div className="font-display text-base text-ink truncate">{b.title}</div>
                <div className="font-body text-xs text-mutedgrey truncate">{b.user_name} · with {b.trainer_name} · {formatDayTime(b.start_time)}</div>
              </div>
              <span className="font-display text-brand">{formatR(b.price)}</span>
              <Tag label={b.status === "pending_payment" ? "pending" : b.status} tone={tone(b.status)} />
              {b.status === "confirmed" ? <Button testID={`refund-${b.id}`} title="Refund" small variant="outline" loading={refund.isPending} onClick={() => refund.mutate(b.id)} /> : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
